
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pc-mix-match').forEach(function (bundle) {

    // ==========================================
    // 1. ELEMENTS AND BUNDLE STATE
    // ==========================================

    const search = bundle.querySelector('.pc-bundle-search');
    const clearButton = bundle.querySelector('.pc-bundle-search-clear');
    const list = bundle.querySelector('.pc-bundle-list');
    const counter = bundle.querySelector('[data-pc-count]');
    const summary = bundle.querySelector('.pc-bundle-selections');
    const cartButton = bundle.querySelector('.pc-bundle-cart');

    const limit = Number(bundle.dataset.bundleSize) || 3;
    const selected = new Map();
    const rows = Array.from(bundle.querySelectorAll('.pc-bundle-row'));

    const suprEnabled = bundle.dataset.suprEnabled === 'true';
    const suprBundleId = bundle.dataset.suprBundleId;
    const suprSellingPlan = Number(bundle.dataset.suprSellingPlan);

    const purchaseOptions = bundle.querySelectorAll(
      'input[name^="pc-purchase-"]'
    );

    const priceSummary = bundle.querySelector('.pc-bundle-total');
    const displayedPrice = bundle.querySelector('[data-pc-bundle-price]');
    const displayedSaving = bundle.querySelector('[data-pc-bundle-saving]');

    let purchaseType =
      bundle.querySelector('input[name^="pc-purchase-"]:checked')?.value
      || 'once';

    // ==========================================
    // 2. PURCHASE OPTION AND PRICE
    // ==========================================

    function updateDisplayedPrice() {
      if (!priceSummary || !displayedPrice || !displayedSaving) {
        return;
      }

      const activeOption = bundle.querySelector(
        'input[name^="pc-purchase-"]:checked'
      );

      if (activeOption) {
        purchaseType = activeOption.value;
      }

      const isSubscription =
        suprEnabled && purchaseType === 'subscription';

      const activeLabel = activeOption?.closest('.pc-purchase-option');

const radioPrice = activeLabel
  ?.querySelector('.pc-purchase-option-details + strong')
  ?.textContent.trim();

      // Use Liquid's stored price if no radio option is present.

const bundlePrices = {
  2: 34.99,
  3: 50.00,
  4: 65.00,
  5: 80.00
};

const basePrice = bundlePrices[limit];

const correctPrice = '£' + (
  isSubscription && limit === 3
    ? basePrice * 0.96
    : basePrice
).toFixed(2);


      const correctSaving = isSubscription
        ? priceSummary.dataset.subscriptionSaving
        : priceSummary.dataset.onceSaving;

      // Only change the DOM when the value is incorrect.
      if (
        correctPrice &&
        displayedPrice.textContent.trim() !== correctPrice
      ) {
        displayedPrice.textContent = correctPrice;
      }

      if (
        correctSaving &&
        displayedSaving.textContent.trim() !== correctSaving
      ) {
        displayedSaving.textContent = correctSaving;
      }
    }

    purchaseOptions.forEach(function (option) {
      option.addEventListener('change', function () {
        if (!option.checked) return;

        purchaseType = option.value;
        update();
      });
    });

    // If a subscription app changes our price, restore the
    // price belonging to the selected purchase option.
    if (priceSummary && displayedPrice && displayedSaving) {
      let correctionQueued = false;

      const priceObserver = new MutationObserver(function () {
        if (correctionQueued) return;

        correctionQueued = true;

        queueMicrotask(function () {
          correctionQueued = false;
          updateDisplayedPrice();
        });
      });

      priceObserver.observe(displayedPrice, {
        childList: true,
        characterData: true,
        subtree: true
      });

      priceObserver.observe(displayedSaving, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    // ==========================================
    // 3. SORT PERFUMES BY REFERENCE
    // ==========================================

    function sortReference(reference) {
      const match = (reference || '').match(/^(\d+)([A-Z]*)$/i);

      return match
        ? {
            number: Number(match[1]),
            suffix: match[2].toUpperCase()
          }
        : {
            number: Infinity,
            suffix: reference || ''
          };
    }

    rows.sort(function (a, b) {
      const first = sortReference(a.dataset.reference);
      const second = sortReference(b.dataset.reference);

      return first.number - second.number ||
        first.suffix.localeCompare(second.suffix);
    });

    rows.forEach(function (row) {
      list.appendChild(row);
    });

    // ==========================================
    // 4. ADD AND REMOVE PERFUMES
    // ==========================================

    function totalSelected() {
      let total = 0;

      selected.forEach(function (item) {
        total += item.quantity;
      });

      return total;
    }

    function changeQuantity(row, change) {
      const id = row.dataset.variantId;
      const existing = selected.get(id);

      const currentQuantity = existing
        ? existing.quantity
        : 0;

      const newQuantity = currentQuantity + change;

      if (newQuantity < 0) return;

      if (change > 0 && totalSelected() >= limit) {
        return;
      }

      if (newQuantity === 0) {
        selected.delete(id);
      } else {
        selected.set(id, {
          title: row.dataset.productTitle,
          quantity: newQuantity,
          price: Number(row.dataset.variantPrice)
        });
      }

      update();
    }

    // Create quantity controls for available perfumes.
    rows.forEach(function (row) {
      const addButton = row.querySelector('.pc-bundle-add');

      if (!addButton) return;

      if (addButton.disabled) {
        row.dataset.available = 'false';
        return;
      }

      const controls = document.createElement('div');
      controls.className = 'pc-bundle-quantity';
      controls.hidden = true;

      const minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'pc-bundle-minus';
      minus.textContent = '−';

      minus.setAttribute(
        'aria-label',
        'Remove one ' + row.dataset.productTitle
      );

      const number = document.createElement('span');
      number.className = 'pc-bundle-number';
      number.textContent = '0';

      const plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'pc-bundle-plus';
      plus.textContent = '+';

      plus.setAttribute(
        'aria-label',
        'Add one ' + row.dataset.productTitle
      );

      controls.append(minus, number, plus);
      addButton.after(controls);

      addButton.addEventListener('click', function () {
        changeQuantity(row, 1);
      });

      minus.addEventListener('click', function () {
        changeQuantity(row, -1);
      });

      plus.addEventListener('click', function () {
        changeQuantity(row, 1);
      });
    });

    // ==========================================
    // 5. UPDATE THE BUNDLE
    // ==========================================

    function update() {
      updateDisplayedPrice();

      const total = totalSelected();

      counter.textContent = total;
      summary.replaceChildren();

      if (total === 0) {
        const empty = document.createElement('p');
        empty.textContent = 'No perfumes selected yet.';
        summary.appendChild(empty);
      }

      // Selected-perfume summary.
      selected.forEach(function (item, id) {
        const line = document.createElement('div');
        line.className = 'pc-selected-item';

        const name = document.createElement('span');
        name.textContent =
          item.quantity + ' × ' + item.title;

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = 'Remove';

        remove.addEventListener('click', function () {
          selected.delete(id);
          update();
        });

        line.append(name, remove);
        summary.appendChild(line);
      });

      // Update quantity controls in the perfume list.
      rows.forEach(function (row) {
        if (row.dataset.available === 'false') {
          return;
        }

        const quantity =
          selected.get(row.dataset.variantId)?.quantity || 0;

        const addButton = row.querySelector('.pc-bundle-add');
        const controls = row.querySelector('.pc-bundle-quantity');
        const number = row.querySelector('.pc-bundle-number');
        const plus = row.querySelector('.pc-bundle-plus');

        addButton.hidden = quantity > 0;
        controls.hidden = quantity === 0;

        addButton.textContent = '+ Add to bundle';
        addButton.disabled = total >= limit;

        number.textContent = quantity;
        plus.disabled = total >= limit;
      });

      cartButton.disabled = total !== limit;

      cartButton.textContent = total === limit
        ? 'Add ' + limit + ' perfumes to cart'
        : 'Select ' + (limit - total) + ' more';
    }

    // ==========================================
    // 6. SEARCH AND FILTER PERFUMES
    // ==========================================

    function filterPerfumes() {
      const query = search.value.trim().toLowerCase();

      // Restore numerical order when search is cleared.
      if (!query) {
        rows.forEach(function (row) {
          row.hidden = false;
          list.appendChild(row);
        });

        list.scrollTop = 0;
        clearButton.hidden = true;
        return;
      }

      const matching = rows.filter(function (row) {
        return (row.dataset.search || '').includes(query);
      });

      // Exact reference first, then prefix, then other matches.
      function priority(row) {
        const reference =
          (row.dataset.reference || '').toLowerCase();

        if (reference === query) return 0;
        if (reference.startsWith(query)) return 1;

        return 2;
      }

      matching.sort(function (a, b) {
        return priority(a) - priority(b);
      });

      rows.forEach(function (row) {
        row.hidden = true;
      });

      matching.forEach(function (row) {
        row.hidden = false;
        list.appendChild(row);
      });

      list.scrollTop = 0;
      clearButton.hidden = false;
    }

    search.addEventListener('input', filterPerfumes);

    clearButton.addEventListener('click', function () {
      search.value = '';
      filterPerfumes();
      search.focus();
    });

    // ==========================================
    // 7. ADD BUNDLE TO SHOPIFY CART
    // ==========================================

    cartButton.addEventListener('click', async function () {
      if (totalSelected() !== limit) return;

      const isSubscription =
        suprEnabled && purchaseType === 'subscription';

      let items;

      if (isSubscription) {
        // Each subscription box gets a unique key.
        // All perfumes in that box share the same key.
        const bundleKey =
          'pc-' +
          Date.now().toString(36) +
          '-' +
          Math.random().toString(36).slice(2, 10);

        items = Array.from(selected.entries()).map(
          function ([variantId, item]) {
            return {
              id: Number(variantId),
              quantity: item.quantity,
              selling_plan: suprSellingPlan,
              properties: {
                _ssBundleGroup: suprBundleId,
                _ssBundleBar: '0',
                _ssBundleKey: bundleKey,
                _ssMixGroup: '0',
                _ssPlanBase: (item.price / 100).toFixed(2),
                _bundle_block_name: 'Build your bundle'
              }
            };
          }
        );

      } else {
        // Preserve the existing one-time cart behaviour.
        items = Array.from(selected.entries()).map(
          function ([variantId, item]) {
            return {
              id: Number(variantId),
              quantity: item.quantity
            };
          }
        );
      }

      cartButton.disabled = true;

      cartButton.textContent = isSubscription
        ? 'Adding your subscription...'
        : 'Adding your bundle...';

      try {
        const root = window.Shopify?.routes?.root || '/';

        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Unable to add your bundle.'
          );
        }

        window.location.href = root + 'cart';

      } catch (error) {
        console.error('Bundle add to cart failed:', error);

        alert(
          error.message ||
          'Something went wrong. Please try again.'
        );

        update();
      }
    });

    // ==========================================
    // 8. INITIAL DISPLAY
    // ==========================================

    update();

  });
});
